/**
 * Build a safe campaign detail path for links, sharing, and navigation.
 * Encodes spaces and special characters so shared URLs do not break.
 */
export function getCampaignPath(slug) {
  const s = String(slug ?? '').trim();
  if (!s) return '/campaigns';
  return `/campaign/${encodeURIComponent(s)}`;
}

export function getCampaignShareUrl(slug, baseUrl) {
  const origin =
    baseUrl ||
    (typeof window !== 'undefined' && window.location?.origin) ||
    process.env.REACT_APP_SITE_URL ||
    '';
  const path = getCampaignPath(slug);
  return `${String(origin).replace(/\/+$/, '')}${path}`;
}
